<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>I would like to thank Sharon Kelly who chairs the writers club in Helensvale, who read and purchased my first book and has always provided such positive feedback; also like to mention Helensvale Library for accepting my first book into all the Gold Coast libraries which was my goal when I started this journey after being an avid reader.</p>
<p>Would also like to acknowledge Brian Gilmour for the laughs we had at the writer’s club and the stimulating conversations; he also supported me by buying my signed book.</p>
<p>Would also like to acknowledge my wife Mandy for reading each chapter as I created it and emailing me back her enjoyment of the plot of my new book <em>Naomi the Night Watchwoman.</em></p>
<p>And of course, finally are Mitchell and Kaitlyn for being great kids who I am very proud of.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?75360166